import CloseIcon from '@mui/icons-material/Close';
import ConfirmIcon from '@mui/icons-material/Check';
import Fab from '@mui/material/Fab';

export default function EditLineToolbar({ onCancelLinePerimeterEdit, onConfirmLinePostFirePerimeterEdit }) {
  return (
    <div>
      <Fab style={{ padding: '0 10px', marginLeft: 3 }} variant="extended" size="medium" color="primary" aria-label="Cancel" onClick={onCancelLinePerimeterEdit}>
        <CloseIcon sx={{ mr: 1 }} />
        Cancel
      </Fab>
      <Fab style={{ padding: '0 10px', marginLeft: 3 }} variant="extended" size="medium" color="primary" aria-label="Confirm" onClick={onConfirmLinePostFirePerimeterEdit}>
        <ConfirmIcon sx={{ mr: 1 }} />
        Confirm
      </Fab>
    </div>
  )
}